import { Fragment, useState, useEffect } from 'react'
import callApi from '../../helpers/callapi'
import moment from 'moment'
import { orderBy } from 'lodash'
import { useDispatch } from 'react-redux'
import config from '../../config'
import { getRounds } from '../../services/config-services'

import { Form, Card, Row, Col, Table } from 'react-bootstrap'

const Books = () => {
  const [roundDate, setRoundDate] = useState()
  const [prizes, setPrizes] = useState([])
  const [prizeBooks, setPrizesBooks] = useState([])
  const [rounds, setRounds] = useState([])
  const [typeCount, setTypeCount] = useState({
    nearBy: 0,
    first: 0,
    second: 0,
    third: 0,
    forth: 0,
    fifth: 0,
    first3Digits: 0,
    last3Digits: 0,
    last2Digits: 0,
  })
  const dispatch = useDispatch()

  const TYPE = {
    nearBy: 'nearBy',
    first: 'first',
    second: 'second',
    third: 'third',
    forth: 'forth',
    fifth: 'fifth',
    first3Digits: 'A',
    last3Digits: 'B',
    last2Digits: 'T',
  }

  const fetchAllRounds = async () => {
    const data = await getRounds()
    setRoundDate(data[0].value)
    setRounds(data.map((r) => ({ roundDate: r.value })))
    //setLoading(false);
    dispatch({ type: 'loading_hide' })
  }
  const fetchAwards = async (query = {}) => {
    try {
      dispatch({ type: 'loading_show' })
      //setLoading(true);
      query.roundDate = roundDate
      const results = await callApi({
        url: '/prizes/books',
        query,
      })
      setPrizes(results.results || [])
      console.log('prizes', prizes)
      dispatch({ type: 'loading_hide' })
      //setLoading(false);
    } catch (error) {
      console.log(error)
      setPrizes([])
      dispatch({ type: 'loading_hide' })
      //setLoading(false);
    }
  }
  useEffect(async () => {
    //setLoading(true);
    fetchAllRounds()
  }, [])
  useEffect(async () => {
    fetchAwards()
  }, [roundDate])

  useEffect(async () => {
    let tempBooks = {}
    prizes.forEach((prize) => {
      const key = prize.roundNo + prize.seriesNo + prize.volume
      tempBooks[key] = tempBooks[key] || {
        rowNo: '',
        roundNo: prize.roundNo,
        volume: prize.volume,
        seriesNo: prize.seriesNo,
        numbers: {},
        lotteryNumbers: [],
      }
      tempBooks[key].numbers[prize.lastTwoDigits] = tempBooks[key].numbers[prize.lastTwoDigits] || []
      tempBooks[key].numbers[prize.lastTwoDigits].push(TYPE[prize.name])

      tempBooks[key].lotteryNumbers.push(prize.lotteryNumber)
      setTypeCount((type) => {
        typeCount[prize.name]++
        //console.log(prize.name);
        return type
      })
    })
    tempBooks = Object.keys(tempBooks)
      .sort()
      .reduce((obj, key) => {
        obj[key] = tempBooks[key]
        return obj
      }, {})
    setPrizesBooks(Object.values(tempBooks))
    console.log('prizesBooks', prizeBooks)
  }, [prizes])

  const RenderNumber = (numbers) => {
    return Object.keys(numbers)
      .sort()
      .map((number, i) => {
        // let prizeType = [...(new Set(numbers[number]))]
        return (
          <span key={i}>
            <span>{number}</span>
            <span style={{ fontSize: '.6rem', color: 'red' }}>{numbers[number].join('')}</span>,
          </span>
        )
      })
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Book Prizes</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <b style={{ marginTop: '17px', marginLeft: '20px' }}>งวดวันที่:</b>
              <Col sm={12} md={6} lg={4}>
                <select
                  className="form-control"
                  placeholder="รอบวันที่"
                  style={{ color: 'black' }}
                  onChange={async (value) => {
                    setRoundDate(value.target.value)
                  }}
                >
                  {rounds &&
                    rounds.map((round, i) => {
                      return (
                        <option key={i} value={round.roundDate}>
                          {round.roundDate}
                        </option>
                      )
                    })}
                </select>

                {/* <Dropdown>
                  <Form.Control
                    as="select"
                    onChange={async (value) => {
                      setRoundDate(value.target.value);
                    }}
                  >
                    {rounds &&
                      rounds.map((round, i) => {
                        return (
                          <option key={i} value={round.roundDate} style={{color:"black"}}>
                            {round.roundDate}
                          </option>
                        );
                      })}
                  </Form.Control>
                </Dropdown> */}
              </Col>
              <Col sm={12} md={4} lg={2}>
                <button className="btn btn-primary light">
                  <a
                    style={{ color: 'black' }}
                    href={`${config.urlHost}/lotteriesPrizesDownloadCsv`}
                    // href={`https://asia-east1-kslplusstaging.cloudfunctions.net/lotteriesPrizesDownloadCsv`}
                  >
                    ดาวน์โหลด
                  </a>
                </button>
              </Col>
            </Row>
          </Form>
          <br />
          {Object.keys(typeCount).map((keyType) => {
            return (
              <p key={keyType} style={{ color: 'black' }}>
                {keyType}
                <span style={{ fontSize: '.6rem', color: 'red' }}>{TYPE[keyType]}</span>: {typeCount[keyType]}
              </p>
            )
          })}

          <Table responsive striped bordered className="verticle-middle">
            <thead>
              <tr>
                <th style={{ width: 50 }}>งวดที่</th>
                <th style={{ width: 50 }}>ชุดที่</th>
                <th style={{ width: 50 }}>เล่มที่</th>
                <th style={{ width: 50 }}>เลข2ตัวท้าย</th>
                <th style={{ width: 50 }}>จำนวน</th>
                <th style={{ width: 200 }}>เลขหวย</th>
              </tr>
            </thead>
            <tbody>
              {prizeBooks.map((prize, i) => {
                return (
                  <tr key={i}>
                    <td>{prize.roundNo}</td>
                    <td>{prize.seriesNo}</td>
                    <td>{prize.volume}</td>
                    {console.log(Object.entries(prize.numbers))}
                    <td>{RenderNumber(prize.numbers)}</td>
                    {/* <td> - </td> */}
                    <td>{Object.keys(prize.numbers).length}</td>
                    <td>{prize.lotteryNumbers.join(', ')}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
      {/* {Object.keys(typeCount).map((keyType) => {
        return (
          <p key={keyType} style={{ color: "black" }}>
            {keyType}
            <span style={{ fontSize: ".6rem", color: "red" }}>
              {TYPE[keyType]}
            </span>
            : {typeCount[keyType]}
          </p>
        );
      })} */}
    </Fragment>
  )
}

export default Books
